<template>
  <div>
    <v-tabs centered v-model="tab" color="accent">
      <v-tab>Category mapping</v-tab>
      <v-tab>Fields mapping</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-row justify="center" class="mt-10 mb-10">
          <v-tooltip top v-if="showEbayMapping || showShopifyMapping">
            <template
              v-slot:activator="{ on }"
              v-if="showEbayMapping || showShopifyMapping"
            >
              <v-icon
                size="50"
                v-if="showEbayMapping || showShopifyMapping"
                v-on="on"
                @click="backToAllPlatforms"
                >mdi-backburger</v-icon
              >
            </template>
            <span v-if="showEbayMapping || showShopifyMapping">Go back</span>
          </v-tooltip>
          <v-col cols="8" v-if="showEbay">
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 12 : 2"
                :class="{ 'on-hover': hover }"
                dark
                color="accent"
                @click="openCategoryMapping('ebay')"
              >
                <v-card-text>
                  <v-row justify="center" class="text-center" align="center">
                    <v-col>
                      <span class="text-h5 basic--text">EBAY</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="8" v-if="showBCF">
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 12 : 2"
                :class="{ 'on-hover': hover }"
                dark
                color="accent"
                @click="openCategoryMapping('bcf.lt')"
              >
                <v-card-text>
                  <v-row justify="center" class="text-center">
                    <v-col>
                      <span class="text-h5 basic--text">bcf.lt</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="8" v-if="showBCFashion">
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 12 : 2"
                :class="{ 'on-hover': hover }"
                dark
                color="accent"
                @click="openCategoryMapping('bcfashion.com')"
              >
                <v-card-text>
                  <v-row justify="center" class="text-center">
                    <v-col>
                      <span class="text-h5 basic--text">bcfashion.com</span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <EbayCategoryMapping v-if="showEbayMapping"></EbayCategoryMapping>
        <ShopifyCategoryMapping
          v-if="showShopifyMapping"
          :platform="shopifyPlatform"
        ></ShopifyCategoryMapping>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import EbayCategoryMapping from "../Platforms/EbayCategoryMapping.vue";
import ShopifyCategoryMapping from "../Platforms/ShopifyCategoryMapping.vue";
export default {
  name: "PlatformMapping",
  components: {
    EbayCategoryMapping,
    ShopifyCategoryMapping,
  },
  props: {},
  computed: {},
  data: () => ({
    tab: null,
    tab1: null,
    showEbay: true,
    showBCF: true,
    showBCFashion: true,
    showEbayMapping: false,
    showShopifyMapping: false,
    shopifyPlatform: "",
  }),
  methods: {
    openCategoryMapping(platform) {
      if (platform == "ebay") {
        this.showBCF = false;
        this.showBCFashion = false;
        this.showShopifyMapping = false;
        this.showEbay = true;
        this.showEbayMapping = true;
      }

      if (platform == "bcfashion.com") {
        this.showEbay = false;
        this.showEbayMapping = false;
        this.showBCF = false;
        this.showBCFashion = true;
        this.showShopifyMapping = true;
        this.shopifyPlatform = platform;
      }
      if (platform == "bcf.lt") {
        this.showEbay = false;
        this.showEbayMapping = false;
        this.showBCFashion = false;
        this.showBCF = true;
        this.showShopifyMapping = true;
        this.shopifyPlatform = platform;
      }
    },
    backToAllPlatforms() {
      this.showShopifyMapping = false;
      this.showEbayMapping = false;
      this.showBCFashion = true;
      this.showBCF = true;
      this.showEbay = true;
    },
  },
};
</script>

<style scoped>
.v-card {
  background-color: red;
}

.v-card:not(.on-hover) {
  opacity: 0.8;
}
</style>